import { render } from "./FileDrop.vue?vue&type=template&id=6e9a6110&scoped=true"
import script from "./FileDrop.vue?vue&type=script&lang=js"
export * from "./FileDrop.vue?vue&type=script&lang=js"

import "./FileDrop.vue?vue&type=style&index=0&id=6e9a6110&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9a6110"]])

export default __exports__